// Cliente HTTP do editor. Same-origin: o Caddy (prod) e o proxy do Vite (dev)
// encaminham /api para o Fastify. Cada função traduz os códigos HTTP das rotas
// (ver src/server/routes/) em resultados tipados.

import type { LeituraSoap, Soap } from './types';

export type ResultadoPareamento =
  | { status: 'ok'; sessionId: string }
  | { status: 'processando' } // 409 — existe mas o rascunho ainda não ficou pronto
  | { status: 'expirado' } // 410 — ficou pronto e a validade de 15 min passou
  | { status: 'limite' } // 429 — rate limit por IP
  | { status: 'invalido' } // 404 — não existe ou já consumido
  | { status: 'erro'; mensagem: string }; // rede/resposta inesperada

export async function parear(code: string): Promise<ResultadoPareamento> {
  let resp: Response;
  try {
    resp = await fetch('/api/pair', {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify({ code }),
    });
  } catch {
    return { status: 'erro', mensagem: 'sem conexão com o servidor' };
  }
  switch (resp.status) {
    case 200: {
      const body = (await resp.json()) as { sessionId: string };
      return { status: 'ok', sessionId: body.sessionId };
    }
    case 409:
      return { status: 'processando' };
    case 410:
      return { status: 'expirado' };
    case 429:
      return { status: 'limite' };
    case 404:
      return { status: 'invalido' };
    default:
      return { status: 'erro', mensagem: `resposta inesperada (${resp.status})` };
  }
}

export async function carregarSoap(id: string): Promise<LeituraSoap | null> {
  const resp = await fetch(`/api/session/${id}/soap`);
  if (resp.status === 404) return null;
  if (!resp.ok) throw new Error(`GET soap falhou (${resp.status})`);
  return (await resp.json()) as LeituraSoap;
}

// PATCH grava a versão do médico. true=ok (204), false=sessão sumiu/não pronta (404).
export async function salvarSoap(id: string, soap: Soap): Promise<boolean> {
  const resp = await fetch(`/api/session/${id}/soap`, {
    method: 'PATCH',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify(soap),
  });
  if (resp.status === 204) return true;
  if (resp.status === 404) return false;
  throw new Error(`PATCH soap falhou (${resp.status})`);
}

// POST /copiada — marca nota_copiada_at e congela os diffs (uma vez). `primeira`
// diz se foi a primeira marcação. null=sessão não encontrada/não pronta.
export async function marcarCopiada(id: string): Promise<{ primeira: boolean } | null> {
  const resp = await fetch(`/api/session/${id}/copiada`, { method: 'POST' });
  if (resp.status === 404) return null;
  if (!resp.ok) throw new Error(`POST copiada falhou (${resp.status})`);
  return (await resp.json()) as { primeira: boolean };
}
